import { render, staticRenderFns } from "./kvAccount.vue?vue&type=template&id=12931fcc&scoped=true&"
import script from "./kvAccount.vue?vue&type=script&lang=js&"
export * from "./kvAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12931fcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12931fcc')) {
      api.createRecord('12931fcc', component.options)
    } else {
      api.reload('12931fcc', component.options)
    }
    module.hot.accept("./kvAccount.vue?vue&type=template&id=12931fcc&scoped=true&", function () {
      api.rerender('12931fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/remote-search/kvAccount.vue"
export default component.exports